module.exports = __webpack_public_path__ + "static/media/storyportal-logo.4d5a21ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/storyportal-logo.png
// module id = 447
// module chunks = 33